import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Breakpoints } from "react-device-breakpoints";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import App from "./app/app";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import "./styles/_index.scss";
const breakpoints = {
  isDesktop: "(max-width: 1024px)",
  isTablet: "(max-width: 1023px) and (min-width: 768px)",
  isMobile: "(max-width: 767px)",
  isSemiPortraitTablet: "(max-width: 600px)",
  isPortraitTablet: "(max-width: 641px)",
};

ReactDOM.render(
  <Provider store={store}>
    <Breakpoints {...breakpoints}>
      <App />
    </Breakpoints>
  </Provider>,
  document.getElementById("root")
);
// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <Breakpoints {...breakpoints}>
//         <App />
//       </Breakpoints>
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

reportWebVitals();
